import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';

import Link         from 'app/components/common/link';
import WorkflowCols from 'app/components/company-admin/grant-system/workflow-cols';
import GrantSysDuck from 'app/ducks/company-admin/grant-system';
import format       from 'app/helpers/format';
import helpers      from 'app/helpers/grant-system';
import paths        from 'app/paths';



const {StageTypes} = helpers;

class WorkflowProfile extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {};
  }

  renderAbove(stage) {
    const apps = (this.props.apps || []).filter(app => app.currentGrantStageId === stage.id);
    return (
      <div className="ca-gfw-kb-astage">
        <div className="ca-gfw-kb-sum">
          {`${apps.length} ${format.pluralize('application', apps.length)}`}
        </div>
      </div>
    );    
  }

  renderBelow(stage) {
    const apps = (this.props.apps || []).filter(app => app.currentGrantStageId === stage.id);
    const now = moment();
    const isApproved = stage.type === StageTypes.SYSTEM_APPROVED;
    return (
      <div className="ca-gfw-kb-bstage">
        {apps.map((app) => {
          const showTime = !!(!app.workflowComplete && app.currentStageAssignedTs);
          const time = showTime ? `${now.diff(moment.unix(app.currentStageAssignedTs), 'day')}d` : '';
          const amtStr = (() => {
            if (isApproved) {
              return (app.amountAwarded != null) ? format.usd(app.amountAwarded) : '';
            }
            return (app.amountRequested != null) ? format.usd(app.amountRequested) : '';
          })();
          return (
            <Link key={app.id} className="ca-gfw-kb-app" href={paths.cadminGrantApp(this.props.company.slug, app.id)}>
              <div key={app.id} className="ca-gfw-kb-app-top">
                <div className="ca-gfw-kb-app-top-num">#{app.number}</div>
                <div className={`ca-gfw-kb-app-top-meta ${isApproved ? 'strong' : ''}`}>{amtStr}</div>
                {!!time && <div className="ca-gfw-kb-app-top-meta">{time}</div>}
              </div>
              <div className="ca-gfw-kb-app-np">{app.nonprofit ? app.nonprofit.name : ''}</div>
              <div className="ca-gfw-kb-app-user">{app.user ? `${app.user.firstName} ${app.user.lastName}` : ''}</div>
            </Link>
          );
        })}
      </div>
    );
  }

  render() {
    const {workflow, className, minColWidth} = this.props;

    return (<>
      <WorkflowCols workflow={workflow} className={`ca-gfw-kb ${className}`} minColWidth={minColWidth} renderBelow={this.renderBelow.bind(this)} renderAbove={this.renderAbove.bind(this)} />
    </>);
  }

}

WorkflowProfile.propTypes = {
  workflow: PropTypes.object.isRequired,
  company: PropTypes.object.isRequired,
  className: PropTypes.string,
  minColWidth: PropTypes.number,
};
WorkflowProfile.defaultProps = {
  className: '',
  minColWidth: 340,
};

const stateToProps = (state) => ({
  apps: GrantSysDuck.Slx.pathProgramApps(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(WorkflowProfile);
